import { useEffect } from 'react';
import { API_CACHE_KEYS, API_PATHS } from '@/modules/common/constants';
import { useToast } from '@pw-tech/omni-ui';
import { useMutation } from '@tanstack/react-query';
import { getErrorMessage } from '@/modules/common/utils';
import { ApiClient } from '@pw-tech/web-sdk';

export const useReRegister = () => {
  const { toast: showToaster } = useToast();

  const { isPending, error, mutate, mutateAsync } = useMutation(
    [API_CACHE_KEYS.RE_REGISTER],
    (body: any) => {
      return ApiClient.post(
        API_PATHS.RE_REGISTER.replace('{applicationId}', body.applicationId),
        body
      );
    }
  );

  useEffect(() => {
    if (error) {
      const errorMessage = getErrorMessage(error, 'Error in re-registering application.');
      showToaster({
        message: errorMessage,
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
      });
    }
  }, [error]);

  return {
    error,
    isPending,
    mutate,
    mutateAsync,
  };
};
